import React, { useState } from 'react';
import axios from 'axios';

const API_URL = 'https://broadcastbackend.onrender.com/api';

export default function HeroSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    const submitWithRetry = async (retries = 2) => {
      try {
        await axios.post(`${API_URL}/submit/contact`, formData, { timeout: 10000 });
        setMessage(`Thank you, ${formData.name}! Your message has been submitted.`);
        setFormData({ name: '', email: '', subject: '' });
        setLoading(false);

        setTimeout(() => setMessage(''), 3000);
      } catch (err) {
        if (retries > 0) {
          // Retry after 2 seconds
          setTimeout(() => submitWithRetry(retries - 1), 2000);
        } else {
          setMessage('Error submitting form. Please try again.');
          setLoading(false);
        }
      }
    };

    submitWithRetry();
  };

  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <h1>Tempes The Future of <span className="highlight-purple">AI-Powered</span> Crypto.</h1>
        <p>Tempes (BGG) is a next-generation cryptocurrency powered by advanced artificial intelligence. Built on blockchain technology, we deliver secure, scalable, and intelligent decentralized solutions that redefine the future of digital finance.</p>
        <button className="book-call-btn">
          Explore BGG
          <i className="fa-solid fa-rocket"></i>
        </button>

        <div className="hero-stats">
          <div className="stat-item">
            <div className="stat-number">10M<span className="stat-highlight">BGG</span></div>
            <p className="stat-label">Fixed Total Supply</p>
          </div>
          <div className="stat-item">
            <div className="stat-number">4<span className="stat-plus">+</span></div>
            <p className="stat-label">Roadmap Phases</p>
          </div>
        </div>
      </div>

      <div className="hero-image">
        <form className="contact-form" onSubmit={handleSubmit}>
          <h3 className="form-title">Get in Touch</h3>

          {message && <div className="form-message">{message}</div>}

          <div className="form-group">
            <label htmlFor="contact-name">Name</label>
            <input
              type="text"
              id="contact-name"
              name="name"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="contact-email">Email</label>
            <input
              type="email"
              id="contact-email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="contact-subject">Subject</label>
            <input
              type="text"
              id="contact-subject"
              name="subject"
              placeholder="Enter subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="form-submit-btn" disabled={loading}>
            {loading ? 'Submitting...' : 'Submit'}
            <i className="fa-solid fa-paper-plane"></i>
          </button>
        </form>
      </div>
    </section>
  );
}
